// extracted by mini-css-extract-plugin
export default {"container":"LayoutAuth_container__9pD1u","content":"LayoutAuth_content__48o7D"};